module.exports = __webpack_public_path__ + "img/7.6af2a028.jpg";